import { pageData } from "@/helpers/CypressHelper";
import Localizer from "@/localization/Localizer";

describe('Desktop - Admin Depot tests', () => {

    beforeEach(() => {
        cy.useUniqueAdminSession();

        cy.visit('/depots');
    });

    it('Opens Depot and tries to save an image exceeding 4MB in size', () => {

        pageData().depot.buttons.edit().click();

        pageData().depot.inputs.file()
            .first()
            .selectFile({
                contents: 'cypress/fixtures/test_picture_large.png',
                fileName: 'test_picture_large.png',
                mimeType: 'data:image/png',
                lastModified: Date.now(),
            }, { force: true });

        cy.get('.athenaeum-alert-message');
    });

    it('Opens Depot and tries to save small image and verifies image is rendered', () => {

        pageData().depot.buttons.create().click();

        pageData().depot.inputs.file()
            .first()
            .selectFile({
                contents: 'cypress/fixtures/test_picture_small.png',
                fileName: 'test_picture_small.png',
                mimeType: 'data:image/png',
                lastModified: Date.now(),
            }, { force: true });

        cy.get('[alt="test_picture_small.png"]');
    });

    it('Opens Depot and tries to provide empty phone number', () => {

        pageData().depot.buttons.edit()
            .click();

        pageData().depot.inputs.phone()
            .clear();

        pageData().depot.buttons.save()
            .click();

        pageData().depot.labels.phone()
            .should('not.exist');
    });

    it('Opens Depot and tries to incorrect empty phone number', () => {

        pageData().depot.buttons.edit()
            .click();

        pageData().depot.inputs.phone()
            .clear()
            .type("+45678");

        pageData().depot.buttons.save()
            .click();

        pageData().depot.labels.phone().should('be.visible').then(($label) => {
            const text = $label.text();
            const expectedText1 = Localizer.genericValidationPhoneNumber;
            const expectedText2 = Localizer.get(Localizer.genericValidationPhoneNumberExactLength, 10);

            // Assert that the text matches either of the two conditions
            expect(text).to.satisfy(
                (msg: string) => msg === expectedText1 || msg === expectedText2
            );
        });
    });

    it('Opens Depot and tries to provide correct phone number', () => {

        pageData().depot.buttons.edit()
            .click();

        pageData().depot.inputs.phone()
            .clear()
            .type("+4534567890");

        pageData().depot.buttons.save()
            .click();

        pageData().depot.labels.phone()
            .should('not.exist');
    });
});